// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3lshT","right":"styles_right__10gs5"};